// extracted by mini-css-extract-plugin
module.exports = {"header":"z_bf","link":"z_cn","content":"z_s","feature":"z_bJ","featureName":"z_cy","featureDescription":"z_cz","featureContent":"z_cB"};